import { assetRequire } from "helpers/asset"

const chainLookup = (imageKey) => ({
  x1: assetRequire(`images/product/ch/icons/1x/${imageKey}.png`),
  x2: assetRequire(`images/product/ch/icons/2x/${imageKey}.png`),
})

const engravingLookup = (imageKey) => ({
  x1: assetRequire(`images/product/ef/1x/${imageKey}.png`),
  x2: assetRequire(`images/product/ef/2x/${imageKey}.png`),
})

// stoneFace: "side" or "front"
const imageMap = (stoneFace = "side") => ({
  as: (imageKey) => ({
    x1: assetRequire(
      `images/product/stones/40px/1x/${stoneFace}/${imageKey}.png`
    ),
    x2: assetRequire(
      `images/product/stones/40px/2x/${stoneFace}/${imageKey}.png`
    ),
  }),
  box: (imageKey) => assetRequire(`images/product/photo_box/${imageKey}`),
  ch: (imageKey) => chainLookup(imageKey),
  ch2: (imageKey) => chainLookup(imageKey),
  chainLength: (imageKey) => ({
    x1: assetRequire(`images/product/ch/length/1x/${imageKey}.png`),
    x2: assetRequire(`images/product/ch/length/2x/${imageKey}.png`),
  }),
  chainType: (imageKey) => ({
    x1: assetRequire(`images/product/ch/type/1x/${imageKey}.png`),
    x2: assetRequire(`images/product/ch/type/2x/${imageKey}.png`),
  }),
  choice: (imageKey) =>
    assetRequire(`images/product/choice_thumbs/${imageKey}`),
  design: (imageKey) =>
    assetRequire(`images/product/photo_box/box_designs/${imageKey}.png`),
  ef: (imageKey) => engravingLookup(imageKey),
  ef2: (imageKey) => engravingLookup(imageKey),
  j3d: () => require("images/product/icons/3d-v2.svg"),
  rw: (imageKey) => require(`images/icons/ring-width-icons/${imageKey}.svg`),
  sc: (imageKey) =>
    assetRequire(`images/product/sc/stonecount_${imageKey}.svg`),
  sku: (imageKey) => ({
    x1: assetRequire(`images/product/sku/1x/${imageKey}.png`),
    x2: assetRequire(`images/product/sku/2x/${imageKey}.png`),
  }),
  stone: (imageKey) => ({
    x1: assetRequire(
      `images/product/stones/40px/1x/${stoneFace}/${imageKey}.png`
    ),
    x2: assetRequire(
      `images/product/stones/40px/2x/${stoneFace}/${imageKey}.png`
    ),
  }),
  sz: (imageKey) =>
    assetRequire(`images/product/sizes/ringsize_${imageKey}.svg`),
})

export const imageLookup = (pref, imageKey, stoneFace = "side") => {
  if (imageKey) {
    const lookup = imageMap(stoneFace)[pref]

    if (lookup) {
      return lookup(imageKey)
    } else if (/^s[0-9]+/.test(pref) || /^face[0-9]+_s[0-9]+$/.test(pref)) {
      return imageMap(stoneFace).stone(imageKey)
    } else if (/m[0-9]+/.test(pref)) {
      return imageMap(stoneFace).sku(imageKey)
    }
  }

  return require("images/icons/jewlr.gif")
}
